import { render, staticRenderFns } from "./MedicineAdd.vue?vue&type=template&id=49705d70&scoped=true&"
import script from "./MedicineAdd.vue?vue&type=script&lang=js&"
export * from "./MedicineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49705d70",
  null
  
)

export default component.exports